import * as React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { CardActionArea } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

interface Props {
    title: string
    to?: string
    image: string
}

const StyledCardContent = styled(CardContent)`
    && {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        height: 30px;
    }
`

const StyledImg = styled.img`
    object-fit: contain;
    height: 90px;
    width: 100%;
    max-width: 100%;
    display: block;
    margin-top: 16px;
    margin-bottom: 16px;
    margin-left: auto;
    margin-right: auto;
`

const StyledDiv = styled.div`
    font-size: 18px;
    line-height: 1.5;
    margin-bottom: 8px;
`

export default function MediaCard({ title, to, image }: Props) {
    const navigate = useNavigate()

    const handleClick = () => {
        if (to) {
            navigate(to)
        }
    }

    return (
        <Card sx={{ maxWidth: 345, height: 200 }} variant='outlined'>
            <CardActionArea onClick={handleClick} sx={{ height: '100%' }}>
                <StyledImg src={image} alt={title} />
                <StyledCardContent>
                    <StyledDiv>{title}</StyledDiv>
                </StyledCardContent>
            </CardActionArea>
        </Card>
    )
}
